<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">

      <div class="row">
        <div class="col-md-12 font-large-1 danger">
          <i class="la la-calendar-check-o font-large-1"></i> Son Cosing Güncellemesi: {{dashboard?.lastUpdate}}
        </div>
      </div>
      <div class="row mt-3">


      <div class="col-xl-3 col-lg-6 col-12">
        <div class="card pull-up">
          <div class="card-content">
            <div class="card-body card_padding">
              <div class="media d-flex">
                <div class="media-body text-left">
                  <h3 class="info">{{dashboard?.reports}}</h3>
                  <h6>Toplam Rapor</h6>
                </div>
                <div>
                  <i class="icon-basket-loaded info font-large-2 float-right"></i>
                </div>
              </div>
             
            </div>
          </div>
        </div>
        </div>


        <div class="col-xl-3 col-lg-6 col-12">
          <div class="card pull-up">
            <div class="card-content">
              <div class="card-body card_padding">
                <div class="media d-flex">
                  <div class="media-body text-left">
                    <h3 class="info">{{dashboard?.mateials}}</h3>
                    <h6>Toplam Hammadde</h6>
                  </div>
                  <div>
                    <i class="icon-pie-chart info font-large-2 float-right"></i>
                  </div>
                </div>
               
              </div>
            </div>
          </div>
          </div>


          <div class="col-xl-3 col-lg-6 col-12">
            <div class="card pull-up">
              <div class="card-content">
                <div class="card-body card_padding">
                  <div class="media d-flex">
                    <div class="media-body text-left">
                      <h3 class="info">{{dashboard?.compounds}}</h3>
                      <h6>Toplam Bileşik</h6>
                    </div>
                    <div>
                      <i class="icon-pie-chart info font-large-2 float-right"></i>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
            </div>
      </div>
    </div>
  </div>
</div>
